import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@chancenwerk/design/components/cr-button.js';
import '@chancenwerk/design/components/cr-flex.js';
import '@chancenwerk/design/components/cr-image.js';
import '@chancenwerk/design/components/cr-input.js';
import '@chancenwerk/design/components/cr-link.js';
import '@chancenwerk/design/components/fonts.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import illuBad from '../assets/levumi_feedback_bad.png';
import illuGood from '../assets/levumi_feedback_good.png';
import illuNeutral from '../assets/levumi_feedback_neutral.png';

/**
 * @customElement campus-component-exercise-levumi-summary
 */
@customElement('campus-component-exercise-levumi-summary')
export class CampusComponentExerciseLevumiSummary extends ChemistryLitElement {
  @property() public prevResult: number | undefined;
  @property() public newResult: number | undefined;

  override render() {
    return html`
      <cr-flex space="xl" padding="md" center crossaxis-center space-between>
        <cr-levumi-text ${css({ fontSize: '2rem' })}>Du hast es geschafft!</cr-levumi-text>
        <cr-levumi-text ${css({ fontSize: '1.5rem' })}>
          Die Auswertung erhältst du von deiner Lernkoordination.
        </cr-levumi-text>

        ${this._evaluateResult()}
      </cr-flex>
    `;
  }

  private _evaluateResult() {
    if (this.newResult === undefined) {
      return this._showNoResult();
    } else if (this.prevResult === undefined) {
      return this._showFirstResult();
    } else if (this.prevResult === this.newResult) {
      return this._showSameResult();
    } else if (this.prevResult > this.newResult) {
      return this._showWorseResult();
    } else if (this.prevResult < this.newResult) {
      return this._showImprovedResult();
    }
  }

  private _showFirstResult() {
    return html` <cr-image disabled mode="width" ${css({ width: '80%' })} .value=${illuNeutral}></cr-image> `;
  }

  private _showImprovedResult() {
    return html` <cr-image disabled mode="width" ${css({ width: '80%' })} .value=${illuGood}></cr-image> `;
  }

  private _showWorseResult() {
    return html` <cr-image disabled mode="width" ${css({ width: '80%' })} .value=${illuBad}></cr-image> `;
  }

  private _showSameResult() {
    return html` <cr-image disabled mode="width" ${css({ width: '80%' })} .value=${illuNeutral}></cr-image> `;
  }

  private _showNoResult() {
    return html` No Result! `;
  }
}
